import Vue from 'vue';

export class Usuario{

    static create(){

        let street = {};

        street.usuario = '';
        street.nome = '';
        street.admin = false;
        street.acesso_cadastros = false;
        street.acesso_monitoramento = false;
        street.acesso_financeiro = false;
        street.acesso_dashboard = false;
        street.eventos = {
            bateria: true,
            ign_off: false,
            ign_on: false,
            entrada1: true,
            panic: true,
            sem_transmissao: false,
            bloqueio: false,
            desbloqueio: false,
            speed: false,
            movement: false,
            cerca_eletronica: false,
            agenda: false
        };
        street.financeiro = {
            boleto_nao_registrado: true,
            cliente_sem_cobranca: true,
            boletos_mensais: true,
            boletos_pagos: true,
            boletos_vencidos_nao_pagos: true,
            previsao_financeira: true,
        };
        return street;
    }

    /**
     *
     * @return {Promise}
     */
    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/usuarios')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static save(json){
        return new Promise((ok, fail) => {

            let promisse = null;

            if(json.id_usuario){
                promisse = Vue.http.put('usuario/by-pk/'+ json.id_usuario, json);
            } else {
                promisse = Vue.http.post('usuario/by-pk/0', json);
            }

            promisse
                .then(() => {
                    ok();
                })
                .catch((e) => {
                    fail(e);
                });

        });
    }

    /**
     *
     * @param id_usuario
     * @return {Promise}
     */
    static async remove (id_usuario){
        return Vue.http.delete('usuario/by-pk/' + id_usuario);
    }

    /**
     *
     * @param id_usuario
     * @return {Promise}
     */
    static byPK(id_usuario){
        return new Promise((ok, fail) => {
            Vue.http.get('usuario/by-pk/'+ id_usuario)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

}
